import axios from "axios";

export default async function getValidateFormDocuments(projectName, formName, documentId){
    return await axios.get(`/project/${projectName}/${formName}/Document/validated/${documentId}`)
}